import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Box from '@rexlabs/box';

import { styled, StyleSheet } from '@rexlabs/styling';
import colorTheme from '../../../utils/color-theme';
import charLimit, { limits } from '../../../utils/char-limit';
import { LargeButton } from '../../button';
import { COLORS } from 'src/theme';
import _ from 'lodash';

const fontFamily = 'Lato, sans-serif';
const defaultStyles = StyleSheet({
  halfPage: {
    width: '300px',
    height: '600px',
    overflow: 'hidden',
    border: '1px solid darkgray',
    display: 'flex',
    flexDirection: 'column'
  },
  primaryImage: {
    height: '280px',
    width: '100%',
    objectFit: 'cover'
  },
  shortHeadline: {
    padding: '20px 20px 25px',
    fontSize: '20px',
    fontWeight: 500,
    fontFamily,
    lineHeight: '24px',
    backgroundColor: '#F8F8F8'
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    padding: '18px 24px 24px',
    backgroundColor: 'white',
    flex: 1
  },
  agentName: {
    fontSize: '32px',
    fontFamily,
    fontWeight: 300,
    lineHeight: '38px',
    marginBottom: '5px'
  },
  agentTitle: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontFamily,
    textTransform: 'uppercase',
    marginBottom: '16px'
  },
  logoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100px',
    padding: '15px 40px'
  },
  logo: {
    width: 'auto',
    maxWidth: 'calc(0.6 * 300px)',
    maxHeight: 'calc(0.7 * 100px)',
    objectFit: 'contain'
  }
});

@styled(defaultStyles)
class HalfPage extends PureComponent {
  static propTypes = {
    shortHeadline: PropTypes.string,
    agentName: PropTypes.string,
    suburb: PropTypes.string,
    buttonText: PropTypes.string,
    brandColor: PropTypes.string,
    primaryImageUrls: PropTypes.object,
    logoUrls: PropTypes.object
  };

  static defaultProps = {
    buttonText: 'Learn more'
  };

  render() {
    const {
      shortHeadline,
      agentName,
      agentPosition,
      agencyName,
      buttonText,
      brandColor,
      backgroundColor,
      primaryImageUrls,
      logoUrls,
      styles: s
    } = this.props;

    const { brandColorBoder } = colorTheme(brandColor);

    return (
      <Box {...s('halfPage')}>
        <img
          {...s('primaryImage')}
          src={_.get(primaryImageUrls, ['crop.square', 'url'])}
        />
        <span {...s.with('shortHeadline')({ color: COLORS.BLACK })}>
          {charLimit(shortHeadline, limits.SHORT_HEADLINE)}
        </span>
        <Box {...s('main')}>
          <span {...s.with('agentName')({ color: COLORS.BLACK })}>
            {agentName}
          </span>
          <span {...s.with('agentTitle')({ color: COLORS.BLACK })}>
            {agentPosition} - {agencyName}
          </span>
          <Box width={114}>
            <LargeButton brandColor={brandColor}>{buttonText}</LargeButton>
          </Box>
        </Box>
        <Box
          {...s.with('logoWrapper')({
            backgroundColor: backgroundColor,
            borderTop: brandColorBoder
          })}
        >
          <img src={_.get(logoUrls, 'original.url')} {...s('logo')} />
        </Box>
      </Box>
    );
  }
}

export default HalfPage;
